module.exports = __webpack_public_path__ + "static/media/25542624_1703511929723991_9183053680099210804_o.a76184ac.jpg";